import { render, staticRenderFns } from "./QuoteRepx.vue?vue&type=template&id=6b76f20c"
import script from "./QuoteRepx.vue?vue&type=script&lang=js"
export * from "./QuoteRepx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b76f20c')) {
      api.createRecord('6b76f20c', component.options)
    } else {
      api.reload('6b76f20c', component.options)
    }
    module.hot.accept("./QuoteRepx.vue?vue&type=template&id=6b76f20c", function () {
      api.rerender('6b76f20c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteRepx.vue"
export default component.exports